// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"b930e789","96":"15c71d8e","216":"57ca4410","365":"3f680647","543":"9d60aedc"}[chunkId] + ".chunk.js";
};